{
    "order": {
        "show": {
            "greeting": {
                "salutation": "Beste { name },",
                "introduction": "Bedankt dat u ervoor gekozen heeft om ONZE ORGANISATIE te steunen met uw bestelling!"
            },
            "orderCard": {
                "title": "Bestelling { orderId }",
                "locationFee": "Bezorgkosten",
                "donation": "Donatie",
                "discount": "Korting"
            },
            "customFields": {
                "title": "Overige informatie"
            },
            "customerCard": {
                "title": "Uw gegevens",
                "date": "Datum",
                "time": "Tijdstip",
                "address": "Adres",
                "pickupPoint": "Ophaallocatie",
                "delivery": "Uw bestelling wordt bij u thuisbezorgd op { date } tussen { time }. Het bij ons bekende adres is { address }.",
                "pickup": "Jouw bestelling ligt voor u klaar bij { pickupPoint } op { date } tussen { time }. U kunt deze ophalen bij { pickupPoint }. { description }"
            },
            "paymentWarning": {
                "title": "Betaling",
                "message": "Let op, je betaling is nog niet ontvangen. Mogelijk is deze vertraagd of mislukt.",
                "action": "Betaling afronden",
                "error": "Kan betaallink niet ophalen."
            },
            "stateAlert": {
                "refunded": "Je bestelling is terugbetaald. We komen niet meer langs. Is dit een foutje? Neem dan contact met ons op via TELEFOON.",
                "deleted": "Je bestelling is geannuleerd. Is dit een foutje? Neem dan contact met ons op via TELEFOON."
            }
        }
    },
    "checkout": {
        "submitLabel": "Plaats bestelling",
        "paymentMethod": {
            "label": "Betaalmethode"
        },
        "service": {
            "label": "Kies de service die u wilt"
        },
        "product": {
            "noInventory": "Er zijn geen tijdvakken beschikbaar met genoeg voorraad voor uw bestelling."
        },
        "timeslot": {
            "dayLabel": "Dag",
            "timeLabel": "Tijdstip"
        },
        "location": {
            "fulfillmentFee": {
                "delivery": "Voor de bezorging op uw adres rekenen we een toeslag van {fee}.",
                "pickup": "Voor het ophalen op deze locatie rekenen we een toeslag van {fee}."
            },
            "unsupportedLocation": "Uw adres ligt niet in het bezorggebied.",
            "allTimeslotsFull": "Helaas zijn alle tijdvakken voor deze postcode bezet."
        },
        "allTimeslotsAtCapacity": "Er zijn geen tijdsloten beschikbaar met genoeg voorraad.",
        "outOfStock": "Helaas is {product} uitverkocht in dit tijdvak. Kies een ander tijdvak of verwijder {product} uit uw bestelling.",
        "customerRemark": {
            "label": "Opmerking",
            "placeholder": "Bijvoorbeeld: 'Bel aan bij de buren als ik er niet ben.'"
        },
        "donation": {
            "label": "Donatie",
            "placeholder": ""
        },
        "errors": {
            "unexpected": "Er gaat iets niet goed, kom op een later moment terug of neem contact met ons op.",
            "validation": "Bestelling ongeldig. Los de fouten en probeer het opnieuw.",
            "closed": "Momenteel is bestellen niet mogelijk. Probeer het later nog eens.",
            "hcaptcha": "HCaptcha verificatie is niet gelukt. Mogelijk bent u een robot.",
            "noTeam": "Er is geen plek voor uw bestelling op het gekozen tijdstip. Kies een ander moment of een andere locatie.",
            "noStock": "Er is niet genoeg voorraad om aan uw bestelling te voldoen. Pas uw bestelling aan en probeer het opnieuw."
        }
    },
    "common": {
        "yes": "Ja",
        "no": "Nee"
    }
}
